const _excluded = ["dynamicImporter", "fallback", "customBoundary"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo, ComponentType } from "react";
import dynamic from "next/dynamic";
import ErrorBoundary from "../common/ErrorBoundary";

/**
 * Wrapper around nextjs dynamic import for s3 federation.
 * Adds error boundaries and fallback options
 * @param {{
 *  dynamicImporter: function(string): Promise,
 *  fallback: function(string): Promise,
 *  customBoundary: ComponentType
 * }} props
 */
const FederationBoundary = _ref => {
  let {
      dynamicImporter,
      fallback = () => null,
      customBoundary: CustomBoundary
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return useMemo(() => {
    const ImportResult = dynamic(() => dynamicImporter().catch(e => {
      console.error(e);
      return fallback();
    }), {
      ssr: false
    });
    const Boundary = CustomBoundary !== undefined ? CustomBoundary : ErrorBoundary;
    return /*#__PURE__*/React.createElement(Boundary, null, /*#__PURE__*/React.createElement(ImportResult, rest));
  }, [dynamicImporter, fallback]);
};
export default FederationBoundary;